<template>
  <div class="container is-fluid">
    <div class="columns">
      <div class="column">
        <h1 class="title is-3">Herzlich Willkommen {{ user.name }}! Hier sind deine Gallerien:</h1>
      </div>
    </div>
    <!--<div class="colums">
      <FolderDropzone />
    </div>-->
    <div class="columns is-multiline">
      <div class="column is-3" v-for="gallery in galleries" :key="gallery.id">
         <router-link
          v-bind:to="'/galleries/' + gallery.id"
        >
          <GalleryPreview v-bind:gallery="gallery" />
        </router-link>
      </div> 
    </div>
  </div>
</template>

<script>
  import GalleryPreview from "../components/GalleryPreview.vue";
  import FolderDropzone from "../components/FolderDropzone.vue";
  import { mapState, mapActions } from 'vuex';

  export default {
    computed: mapState(['user', 'galleries']),
    components: {
      GalleryPreview,
      FolderDropzone
    },
    created() {
      this.getGalleries();
      this.getFriends();
    },
    methods: {
      ...mapActions(["getGalleries", "getFriends"])
    }
  }
</script>
